import { type SharedPageAttributes } from './generated/SharedPageAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import {
  type SharedPageAccessEnum,
  type SharedPageAccessEnum_value,
} from './generated/types';

interface SharedPage extends SharedPageAttributes {}

@model
class SharedPage extends ApplicationModel {
  // Start auto-generated
  static typename: 'SharedPage' = 'SharedPage';
  get typename(): 'SharedPage' {
    return 'SharedPage';
  }

  static internalTypename: 'SharedPage' = 'SharedPage';
  get internalTypename(): 'SharedPage' {
    return 'SharedPage';
  }

  static inputType = 'SharedPageAttributes!';

  static filterType = 'SharedPageFilters!';
  static filters = { pageId: 'ID!', id: '[ID!]' };

  static fields = {
    access: attr({ writable: true, readable: true }),
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    page: attr.belongsTo({ readable: true, typename: 'Page' }),
    user: attr.belongsTo({ readable: true, typename: 'User' }),
  };
  // End auto-generated

  /**
   * A lowercase human-readable string for the specified access type.
   */
  static permissionString(
    accessEnum: SharedPageAccessEnum | SharedPageAccessEnum_value
  ) {
    const { READ_ONLY, READ_ANNOTATE, READ_WRITE } =
      aha.enums.SharedPageAccessEnum;

    if (typeof accessEnum !== 'string' && accessEnum?.value) {
      accessEnum = accessEnum.value;
    }

    switch (accessEnum) {
      case READ_ONLY.value:
        return 'view only';
      case READ_ANNOTATE.value:
        return 'view and comment';
      case READ_WRITE.value:
        return 'edit';
    }
  }

  /**
   * What you would call someone who holds the specified level of access.
   *
   * @param {aha.enums.SharedPageAccessEnum.values} accessEnum
   * @returns {string}
   */
  static permissionHolderType(accessEnum) {
    const { READ_ONLY, READ_ANNOTATE, READ_WRITE } =
      aha.enums.SharedPageAccessEnum;

    if (accessEnum?.value) {
      accessEnum = accessEnum.value;
    }

    switch (accessEnum) {
      case READ_ONLY.value:
        return 'Viewer';
      case READ_ANNOTATE.value:
        return 'Reviewer';
      case READ_WRITE.value:
        return 'Editor';
      case 'OWNER':
        return 'Owner';
    }
  }
}

export default SharedPage;
